import { render, staticRenderFns } from "./checkbox-switch.vue?vue&type=template&id=20712102&scoped=true&"
import script from "./checkbox-switch.vue?vue&type=script&lang=js&"
export * from "./checkbox-switch.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-switch.vue?vue&type=style&index=0&id=20712102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20712102",
  null
  
)

export default component.exports